import React from 'react'

const FooterCreditTicket = () => {
    return (
        <>
            <p className=''>FIRMA: ____________________________________</p>
            <p className=''>NOMBRE:</p>

            <br />
            <br />

            <p className='text__bold receipt__text__center'>FABRICANTE DE SOFTWARE GENESIS</p>
            <p className='text__bold receipt__text__center'>NIT: 900130563-7</p>
        </>
    )
}

export default FooterCreditTicket